import React, { useState } from "react";
import styles from "./SupervisorDashboard.module.css";
import { Card, Divider, List, Progress, Select, Tooltip } from "antd";
import { Table } from "antd";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";
import { Dropdown, Modal, SubmitButton, TextComponent } from "../../../components";
import { ReactComponent as DepartmentFilterIcon } from "../../../assets/images/departmentFilter.svg";
import { useNavigate } from "react-router-dom";

const { Option } = Select;


const columns = [
  {
    title: "No",
    dataIndex: "No",
    key: "No",
  },
  {
    title: "Task",
    dataIndex: "Task",
    key: "Task",
  },
  {
    title: "Time",
    dataIndex: "Time",
    key: "Time",
  },
  {
    title: "Reason",
    key: "Reason",
    dataIndex: "Reason",
  },
];
const data = [
  {
    key: "1",
    No: "1",
    Task: "Dough and batter mixing",
    Time: " 6:10 AM",
    Reason: "Task flagged due to incorrect ingredient ratios.",
  },
  {
    key: "2",
    No: "2",
    Task: "Baguettes, rolls, loaves",
    Time: "7:00 AM",
    Reason: "Proofing time or temperature was not followed.",
  },
  {
    key: "3",
    No: "3",
    Task: "Filling, stacking, and crumb coating",
    Time: "7:30 AM",
    Reason:
      "Oven temperature or baking time did not match production standards..",
  },
  {
    key: "4",
    No: "4",
    Task: "Dough preparation and portioning",
    Time: "7:30 AM",
    Reason:
      "Flagged for potential cross-contact with allergen-containing ingredients.",
  },
  {
    key: "5",
    No: "5",
    Task: "Rotation of baked goods  ",
    Time: " 7:45 AM",
    Reason: "Items stored at incorrect temperature or humidity levels.",
  },
  {
    key: "6",
    No: "6",
    Task: "Sealing and shelf-life management",
    Time: " 7:45 AM",
    Reason: "Packaging task incomplete or labeling missing.",
  },
];

const SupervisorDashboard = () => {
  const navigate = useNavigate()
  const [checkOut, setCheckOut] = useState(false)

  const OverviewData = [
    {
      id: 1,
      logo: require("../../../assets/images/staticImages/OverviewIcon1.png"),
      name: "Today’s Tasks",
      price: 130,
    },
    {
      id: 2,
      logo: require("../../../assets/images/staticImages/OverviewIcon2.png"),
      name: "Total Task",
      price: 130,
    },
    {
      id: 3,
      logo: require("../../../assets/images/staticImages/OverviewIcon3.png"),
      name: "Tasks Completed",
      price: 130,
    },
  ];
  const AlertsData = [
    {
      id: 1,
      text: "Task # 2134 has been approved from Supervisor!",
      time: "5m ago",
    },
    {
      id: 2,
      text: "Task # 2159 has been completed!",
      time: "5m ago",
    },
    {
      id: 3,
      text: "Task # 2137 has been approved from Supervisor!",
      time: "7m ago",
    },
    {
      id: 4,
      text: "Task # 2137 has been approved from Supervisor!",
      time: "7m ago",
    },
  ];
  const tasks = [
    {
      orderId: "153485",
      taskId: "245",
      item: "Pretzel",
      quantity: "01 Dozen",
      assignedFrom: "John Smith",
      dueDate: "Jun 20, 2025",
    },
    {
      orderId: "153485",
      taskId: "245",
      item: "Pretzel",
      quantity: "01 Dozen",
      assignedFrom: "John Smith",
      dueDate: "Jun 20, 2025",
    },
    {
      orderId: "153485",
      taskId: "245",
      item: "Pretzel",
      quantity: "01 Dozen",
      assignedFrom: "John Smith",
      dueDate: "Jun 20, 2025",
    },
    {
      orderId: "153485",
      taskId: "245",
      item: "Pretzel",
      quantity: "01 Dozen",
      assignedFrom: "John Smith",
      dueDate: "Jun 20, 2025",
    },
  ];
  const departmentTypes = [
    { id: 1, value: "Station" },
    { id: 2, value: "Mixing" },
    { id: 3, value: "Make Up" },
    { id: 4, value: "Proofing" },
    { id: 5, value: "Chill" },
    { id: 6, value: "Oven" },
    { id: 7, value: "Assembly" },
    { id: 8, value: "Packaging" },

  ];

  const [department, setdepartment] = useState(departmentTypes[0]);

  const renderOverview = (item, index) => {
    return (
      <div className={styles.rj_listItem}>
        <img src={item?.logo} style={{ width: "15% ", objectFit: "contian" }} />
        <TextComponent padding={"0px"} text={item?.name} color={"#808080"} />
        <TextComponent
          padding={"0px"}
          text={item?.price}
          className={styles.price}
          fontSize="var(--dashboard_tabs-font-size)"
          fontFamily="Urbanist-bold"
        />
      </div>
    );
  };
  const renderAlerts = (item, index) => {
    return (
      <div className={styles.ra_listItem}>
        <TextComponent text={item?.text} />
        <TextComponent text={item?.time} />
      </div>
    );
  };

  const [checkInTime, setCheckInTime] = useState(null);
  const [checkOutTime, setCheckOutTime] = useState(null);

  const formatTime = (date) => {
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleCheckIn = () => {
    const now = new Date();
    setCheckInTime(formatTime(now));
  };

  const handleCheckOut = () => {
    const now = new Date();
    setCheckOutTime(formatTime(now));
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftDiv}>
        <div className={styles.HeaderDiv}>
          <TextComponent text="Welcome, " className={styles.SubHeading} />
          <TextComponent text="John!" className={styles.Name} />
        </div>
        <div className={styles.check_container}>
          <div className={styles.check_in}>
            <div className={styles.checkInContainer}>
              <TextComponent text={`Check-In`} className={styles.SmallHeading} />
              <TextComponent text={`Check-Out`} className={styles.SmallHeading} />
            </div>
            <div className={checkInTime ? styles.check_time : styles.no_time}>
              <TextComponent
                text={checkInTime ? checkInTime : "---"}
                className={styles.SmallHeadingTime}
              />

              <TextComponent
                text={checkOutTime ? checkOutTime : "---"}
                className={styles.SmallHeadingTime}
              />
            </div>
          </div>
          <div className={styles.check_out}>
            <div className={styles.checkout_btn}>
              {!checkInTime ? (
                <SubmitButton
                  title="Check-In"
                  secondary
                  onClick={handleCheckIn}
                  style={{ width: "100%" }}
                />
              ) : !checkOutTime ? (
                <SubmitButton
                  title="Check-Out"
                  secondary
                  // onClick={handleCheckOut}
                  onClick={() => setCheckOut(true)}
                  style={{ width: "100%" }}
                />
              ) : (
                <SubmitButton
                  title="Check-Out"
                  secondary
                  disabled
                  style={{ width: "100%", opacity: 0.6 }}
                />
              )
              }
            </div>
          </div>
        </div>
        {/* Overview container */}
        <div className={styles.OverviewDiv}>
          <div className={styles.OverviewHeadingDiv}>
            <TextComponent text="Order" className={styles.SubHeading} />
          </div>
          <div>
            <List
              dataSource={OverviewData}
              renderItem={renderOverview}
              style={{ marginTop: 10 }}
              grid={{
                gutter: 1,
                xs: 1,
                sm: 2,
                md: 2,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
            />
          </div>
        </div>
        {/* Overview container */}
        {/* Alerts container */}
        <div className={styles.OverviewDiv}>
          <div className={styles.OverviewHeadingDiv}>
            <TextComponent text="Alerts" className={styles.SubHeading} />
          </div>
          <div className={styles.ListDiv}>
            <List
              dataSource={AlertsData}
              renderItem={renderAlerts}
              style={{ marginTop: 10 }}
              grid={{
                gutter: 16,
                xs: 1,
                sm: 1,
                md: 1,
                lg: 1,
                xl: 1,
                xxl: 1,
              }}
            />
          </div>
        </div>
        {/* Alerts container */}
      </div>

      {/* Right Div */}
      <div className={styles.rightDiv}>
        <TextComponent text="Assigned Tasks" className={styles.SmallHeading} />

        <div className={styles.selectorDiv}>
          <div className={styles.selectorLabel}>
            <DepartmentFilterIcon width={20} height={20} />
            <span className={styles.selectorText}>Department</span>
          </div>
          <Dropdown
            value={department}
            className={styles.selectorSelect}
            DropdownContainer={styles.DropdownContainer}
            inputClass={styles.DropDownInnerInput}
            options={departmentTypes}
            onChange={(e) => {
              setdepartment(e);
            }}
          />
        </div>

        <div className={styles.taskList}>
          {tasks.map((task, index) => (
            <Card key={index} className={styles.taskCard}>
              <div className={styles.cardHeader}>
                <TextComponent
                  text={`Order # ${task.orderId}`}
                  className={styles.SmallHeading}
                />
                <TextComponent
                  text={`Task # ${task.taskId}`}
                  color={"var(--success-color)"}
                />
              </div>
              <Divider style={{ margin: "8px 0" }} />
              <div className={styles.cardContent}>
                <div className={styles.cardContentItem}>
                  <TextComponent text={`Item: `} />
                  <TextComponent text={task.item} />
                </div>
                <div className={styles.cardContentItem}>
                  <TextComponent text={`Quantity: `} />
                  <TextComponent text={task.quantity} />
                </div>
                <div className={styles.cardContentItem}>
                  <TextComponent text={"Assigned: "} />
                  <TextComponent text={task.assignedFrom} />
                </div>
                <div className={styles.cardContentItem}>
                  <TextComponent text={`Due Date:`} />
                  <TextComponent text={task.dueDate} />
                </div>
              </div>
              <SubmitButton
                title={"View Task"}
                primary
                style={{ width: "100%" }}
                onClick={() => navigate("/supervisor/RecipeProduction/OngoingTask")}
              />
            </Card>
          ))}
        </div>
      </div>

      {/* ////////////////////////CheckOut modal ///////////////// */}
      <Modal
        open={checkOut}
        onCancel={() => { setCheckOut(false) }}
        className={styles.modalCont}
        title={"Checkout"}
        headingClass={styles.modalHeading}
        width={"400px"}
        twoButton
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickCancelButton={() => setCheckOut(false)}
        onClickOkButton={() => {
          handleCheckOut()
          setCheckOut(false)
        }}
        type={"password"}
      >
        <TextComponent text={"Are you sure you want to checkout."} />
      </Modal>
    </div>
  );
};

export default SupervisorDashboard;
